export interface IKazooIdToken {
  kwSessionId?: string; // KW adds this so it appears in logs.
  aud: string;
  exp: number;
  isPulseOnlyIdentifier?: boolean;
  pulseCompanyId?: number;
  pulseUserId?: number;
  pulseToken?: string;
  pulseEmail?: string;
  pulseEmployeeId?: string;
  kazooPersonId?: string;
  hgToken?: string;
  hgActAsUserToken?: string;
  hgUserId?: string;
  hgGroupId?: string;
  /**
   * Comma separated list of PASCAL_CASE role names.
   */
  pulseRoles?: string;
  iat: number;
  iss: string;
  origin: string;
  sub: string;
  workspace: string;
  locale?: string;
  yeiToken?: string;
  yeiUserId?: string;
  yeiHost?: string;
  hgHost?: string;
  /**
   * Defaults to the string "none".  Don't treat a truthy value in this field as
   * an indication that the user is being impersonated; use
   * `currentUser.ids.yeiImpersonatingUserId` instead.
   */
  yeiImpersonatingUserId?: string;
  isCrossSell?: boolean;
  // used to identify some in-process calls like calls from login, import, writeback, rewards, integrations etc.
  robot?: AllowedRobot;
  superadminSub?: string;
  /** WorkOS session ID, present when authenticated via WorkOS */
  wosSessionId?: string;
}

/**
 * Array of all valid robots.
 * Add your robot to this list to give it access to service contexts and isRobot AuthZ checks.
 */
export const ROBOTS = [
  "activity-feed",
  "activities",
  "administration",
  "api-activities",
  "api-ai-assistant",
  "api-directory/cdc",
  "api-directory",
  "api-awards",
  "api-awards/cdc",
  "api-batches",
  "api-bulk-recognitions",
  "api-engagement",
  "api-goals",
  "api-identity",
  "api-identity-migration",
  "api-incentives",
  "api-incentives-migration",
  "api-indexer",
  "api-insights",
  "api-insights-dashboards",
  "api-interactions",
  "api-legacy-surveys/cdc",
  "api-lockstep",
  "api-notifications",
  "api-points",
  "api-pulse-wrapper",
  "api-recognitions",
  "api-reports",
  "api-rewards",
  "api-settings",
  "api-yei-migration",
  "authentication",
  "check-ins",
  "feedback",
  "identity",
  "imports",
  "ingestion",
  "integrations",
  "layout",
  "legacy-highground-data",
  "login",
  "metrics",
  "notifications",
  "points",
  "point-refresh",
  "provisioning",
  "recognitions",
  "rewards",
  "settings",
  "sync-ups",
  "talent",
  "uploads",
  "users",
  "writeback",
] as const;

type AllowedRobotTuple = typeof ROBOTS;
export type AllowedRobot = AllowedRobotTuple[number];
